import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';

export default async function CouponList(context: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/benefit_code/is_automate_pro_list', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  return res;
}
